/**
 * 语言代码转换为中文名称的工具函数
 * @param langCode 语言代码（如：en, zh, ja, ko等）
 * @returns 中文语言名称
 */
export const getLanguageName = (langCode: string): string => {
  const languageMap: Record<string, string> = {
    'en': '英语',
    'zh': '中文',
    'ja': '日语',
    'de': '德语',
    'fr': '法语',
    'es': '西班牙语',
    'ko': '韩语',
    'ar': '阿拉伯语',
    'ru': '俄语',
    'nl': '荷兰语',
    'it': '意大利语',
    'pl': '波兰语',
    'pt': '葡萄牙语',
    'vi': '越南语',
    'id': '印尼语'
  };
  
  return languageMap[langCode] || langCode;
};

/**
 * 获取所有支持的语言列表
 * @returns 语言代码和中文名称的映射对象
 */
export const getAllLanguages = (): Record<string, string> => {
  return {
    'en': '英语',
    'zh': '中文',
    'ja': '日语',
    'de': '德语',
    'fr': '法语',
    'es': '西班牙语',
    'ko': '韩语',
    'ar': '阿拉伯语',
    'ru': '俄语',
    'nl': '荷兰语',
    'it': '意大利语',
    'pl': '波兰语',
    'pt': '葡萄牙语',
    'vi': '越南语',
    'id': '印尼语'
  };
};

/**
 * 检查语言代码是否支持
 * @param langCode 语言代码
 * @returns 是否支持该语言代码
 */
export const isLanguageSupported = (langCode: string): boolean => {
  const languages = getAllLanguages();
  return langCode in languages;
};

/**
 * 将中文语言名称转换为语言代码（与 Home、视频详情页中的逻辑保持一致）
 * @param languageName 中文语言名称（如：中文、英文、英语、日文、日语等）
 * @returns 语言代码，默认返回 zh
 */
export const getLanguageCodeFromName = (languageName: string): string => {
  switch (languageName) {
    case '中文':
      return 'zh';
    case '英文':
    case '英语':
      return 'en';
    case '日文':
    case '日语':
      return 'ja';
    case '韩文':
    case '韩语':
      return 'ko';
    case '德语':
      return 'de';
    case '法语':
      return 'fr';
    case '西班牙语':
      return 'es';
    case '阿拉伯语':
      return 'ar';
    case '俄语':
      return 'ru';
    case '荷兰语':
      return 'nl';
    case '意大利语':
      return 'it';
    case '波兰语':
      return 'pl';
    case '葡萄牙语':
      return 'pt';
    case '越南语':
      return 'vi';
    case '印尼语':
      return 'id';
    default:
      return 'zh';
  }
};